<div class="contenedor">
  <ng-multiselect-dropdown
    class="customClass"
    [placeholder]="'Selecciona alguna opción'"
    [settings]="dropdownSettings"
    [data]="dropdownList"
    [(ngModel)]="selectedItems"
    (onSelect)="onItemSelect($event)"
    (onSelectAll)="onSelectAll($event)"
    (onDeSelect)="onItemDeSelect($event)"
    (onDeSelectAll)="onDeSelectAll($event)"
  >
  </ng-multiselect-dropdown>
</div>
